import { Link } from "react-router-dom";
import { WordMark } from "@/components/brand/Logo";

const COLUMNS = [
  {
    title: "Product",
    items: [
      { label: "Home", to: "/" },
      { label: "How it works", to: "/how-it-works" },
      { label: "For Authors", to: "/#authors" },
      { label: "For Beta Readers", to: "/#readers" },
    ],
  },
  {
    title: "Community",
    items: [
      { label: "Handbook", to: "/handbook" },
      { label: "Community Guidelines", to: "/community-guidelines" },
      { label: "Coffee Chats", to: "/coffee-chats" },
      { label: "Blog", to: "/blog" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t bg-[hsl(var(--sb-cream))] mt-12 md:mt-24">
      <div className="container-page py-8 md:py-14 grid md:grid-cols-4 gap-6 md:gap-10">
        <div className="md:col-span-2 max-w-sm">
          <WordMark />
          <p className="mt-3 md:mt-4 text-sm text-muted-foreground leading-snug md:leading-relaxed">
            Where Great Stories Meet Great Readers. Last Bookmark is the marketplace built for
            authors and beta readers — trust, relationships, quality.
          </p>
        </div>
        {COLUMNS.map((c) => <FooterCol key={c.title} title={c.title} items={c.items} />)}
      </div>
      <div className="border-t">
        <div className="container-page py-4 md:py-5 flex flex-col sm:flex-row items-center justify-between gap-2 md:gap-3 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Last Bookmark LLC. Built for better author-reader connections.</span>
          <span className="flex flex-wrap gap-x-3 md:gap-x-4 gap-y-1 justify-center sm:justify-end">
            <Link to="/faq" className="link-underline" data-testid="footer-faq">FAQ</Link>
            <Link to="/beta-terms" className="link-underline" data-testid="footer-beta-terms">Beta Terms</Link>
            <Link to="/privacy" className="link-underline" data-testid="footer-privacy">Privacy</Link>
            <Link to="/terms" className="link-underline" data-testid="footer-terms">Terms</Link>
            <Link to="/community-guidelines" className="link-underline" data-testid="footer-community-guidelines">Guidelines</Link>
            <Link to="/payment-guidance" className="link-underline" data-testid="footer-payment-guidance">Payment Guidance</Link>
            <Link to="/contact" className="link-underline" data-testid="footer-contact">Contact</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2 md:mb-4">{title}</h4>
      <ul className="space-y-1.5 md:space-y-2 text-sm">
        {items.map((i) => (
          <li key={i.label}>
            <FooterLink to={i.to} label={i.label} />
          </li>
        ))}
      </ul>
    </div>
  );
}

// Anchor links (e.g. "/#authors") use plain <a> so React Router doesn't strip
// the hash; internal routes use <Link> for SPA nav.
function FooterLink({ to, label }) {
  const testid = `footer-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  const isHash = to.includes("#");
  const className = "text-foreground/80 hover:text-foreground link-underline";
  if (isHash) return <a href={to} className={className} data-testid={testid}>{label}</a>;
  return <Link to={to} className={className} data-testid={testid}>{label}</Link>;
}
